import React, { Component } from 'react'
import uuid from 'uuid'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {setSensor} from '../actions/scActions'

class DropDownSensors extends Component {

    render () {
        let sensors =[{id:'12',name:'Temperature'},
            {id:'13',name:'Humidity'},
            {id:'7',name:'Noise'},
            {id:'14',name:'Light'},
            {id:'15',name:'NO2'},
            {id:'16',name:'CO'},
            {id:'21',name:'Wifi'}]
        let sensorItems;

        sensorItems = sensors.map(sensorItem => {
            return (
                <option key={uuid.v4()} value={sensorItem.id}>{sensorItem.name}</option>
            )
        });

        return (
            <div className="col-sm-4">
                <label>Sensor</label>
                <select className="form-control" value={this.props.sc.sensorId} onChange={(event)=>this.props.changeSensor(event.target.value)} >
                    {sensorItems}
                </select>
            </div>
        )
    }
}

DropDownSensors.PropTypes = {
    sensorId: PropTypes.number,
    changeSelect: PropTypes.func
}


const mapStateToProps = (state) => {
    return {
        sc: state.scReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        changeSensor: (id) => {
            dispatch(setSensor(id))
        }
    }
}

export default connect (mapStateToProps,mapDispatchToProps)(DropDownSensors)


// WEBPACK FOOTER //
// ./src/containers/DropDownSensors.js